<template>
  <div class="container">
    <Navbar />
    <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link tag="li" :to="{ name: 'MyRestaurants' }">
            <a>My Restaurant(s)</a>
          </router-link>
        </li>
        <li
          v-if="this.isRestExists"
          class="breadcrumb-item active"
          aria-current="page"
        >
          <router-link
            tag="li"
            :to="{
              name: 'CurrentRestaurantMenu',
              params: { id: restNum, restId: restId },
            }"
          >
            {{ this.userName }}
          </router-link>
        </li>
        <li
          v-if="this.isRestExists"
          class="breadcrumb-item active"
          aria-current="page"
        >
          Update
        </li>
      </ol>
    </nav>
    <div v-if="this.isRestExists" class="add-new-restaurant-page">
      <p>
        {{ userName }} <faIcons :icon="['fas', 'dot-circle']" />
        {{ userAddress }}
      </p>
      <!-- Add new Modifier -->
      <form method="post" action="#" enctype="multipart/form-data">
        <div class="row g-3 align-items-center mb-3">
          <div class="col-auto d-block mx-auto">
            <div
              class="form-floating"
              :class="{ 'form-data-error': catNameErr }"
            >
              <input
                type="text"
                id="userNameInput"
                placeholder="Modifier Name"
                class="form-control w300"
                @keyup="validateCategoryName($event)"
                @change="validateCategoryName($event)"
                v-model.trim="catName"
              />
              <label for="userNameInput"
                ><faIcons :icon="['fas', 'sitemap']" /> Modifier Name</label
              >
              <span class="error-feedback" v-if="catNameErr">
                {{ catNameMsg }}
              </span>
            </div>
          </div>
        </div>
        <div class="row g-3 align-items-center mb-3">
          <div class="col-auto d-block mx-auto">
            <div
              class="form-floating"
              :class="{ 'form-data-error': maxSelectionErr }"
            >
              <select
                id="maxSelection"
                placeholder="User Role"
                class="form-select w300"
                @change="validateMaxSelection($event)"
                @keyup="validateMaxSelection($event)"
                v-model.trim="maxSelection"
                aria-label="maxSelection"
              >
                <option value="" disabled>Select From Below List</option>
                <option value="all">Can select all</option>
                <option v-for="ii in 100" :value="ii" :key="ii">
                  {{ ii }}
                </option>
              </select>
              <label for="maxSelection"
                ><faIcons :icon="['fas', 'sitemap']" /> Max. for each item
                selection</label
              >
              <span class="error-feedback" v-if="maxSelectionErr">
                {{ maxSelectionMsg }}
              </span>
            </div>
          </div>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-2">
          <button
            class="btn btn-outline-success"
            @click.prevent="UpdateCurrentMenuCategory()"
            v-if="signUpBtn"
          >
            <faIcons :icon="['fas', 'sitemap']" /> Update Current Modifier
          </button>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <div class="alert alert-success" role="alert" v-if="resultSuccess">
            {{ resultSuccessMsg }}
          </div>
          <div class="alert alert-danger" role="alert" v-if="resultErr">
            {{ resultErrMsg }}
          </div>
        </div>
        <div class="row d-grid gap-2 w300 col-auto d-block mx-auto mb-3">
          <router-link
            class="btn btn-outline-primary"
            :to="{
              name: 'CurrentRestaurantMenu',
              params: { id: restNum, restId: restId },
            }"
          >
            <faIcons :icon="['fas', 'undo']" /> Never mind, go back
          </router-link>
        </div>
      </form>
    </div>
    <div v-else>
      <!-- Show error if no restaurant matches this Criteria -->
      <div class="alert alert-dark" role="alert">
        <p>
          No restaurant found. Make sure you click in the right restaurant name.
        </p>
      </div>
      <router-link tag="li" :to="{ name: 'MyRestaurants' }">
        <a>Go back to my restaurant(s)</a>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapMutations, mapGetters } from "vuex";
import Navbar from "@/components/Header/Navbar.vue";
export default {
  name: "UpdateMenuModifier",
  components: {
    Navbar,
  },
  data() {
    return {
      user: {
        uId: "",
        userId: "",
        uName: "",
        uEmail: "",
        uPassword: "",
        uMemberSince: "",
        uAddress: "",
        uPhone: "",
        uRole: "",
        uRoleIs: "",
      },
      //cat
      catName: "",
      catNameErr: false,
      catNameMsg: "",
      iscatNameValidated: false,
      //# of each item selection
      maxSelection: "",
      maxSelectionErr: false,
      maxSelectionMsg: "",
      ismaxSelectionValidated: false,
      //Restaurant Info from URL
      restId: this.$route.params.restId,
      restNum: this.$route.params.id,
      //cat id
      catId: this.$route.params.modifierId,
      //address
      userAddress: "",
      userAddressErr: false,
      userAddressMsg: "",
      isuserAddressValidated: false,
      //phone
      userPhone: "",
      userPhoneErr: false,
      userPhoneMsg: "",
      isuserPhoneValidated: false,
      //name
      userName: "",
      userNameErr: false,
      userNameMsg: "",
      isuserNameValidated: false,

      resultSuccess: false,
      resultSuccessMsg: "",
      resultErr: false,
      resultErrMsg: "",
      image: "",
      is_DB_Connected: "",
      db_connection_msg: "",
      // apiMainUrl: "http://localhost/php/login-system-php-vue-2021/myData.php",
      apiMainUrl: this.$store.getters.MainUrl, //call global variable
      signUpBtn: true,
      isRestExists: false,
    };
  },
  mounted() {
    let user = localStorage.getItem("current-user-data");
    let currentRestaurants = localStorage.getItem("current_restaurants_data");
    let currentRestaurant = JSON.parse(currentRestaurants).filter(
      (restInfo) =>
        restInfo.id == this.restNum && restInfo.rest_id == this.restId
    );
    let currentModifiers = localStorage.getItem(
      "current_user_menu_modifiers_data"
    );
    let currentModifier = JSON.parse(currentModifiers).filter(
      (modifierInfo) =>
        modifierInfo.group_name_rand_id == this.catId &&
        modifierInfo.rest_id == this.restId
    );
    if (user && currentRestaurants) {
      //set rest info
      if (currentRestaurant.length > 0 && currentModifier.length > 0) {
        console.table(currentRestaurant);
        console.table(currentModifier[0]);
        console.log(this.catId);
        console.log(this.restId);
        this.maxSelection = currentModifier[0].max_selection;
        console.log("Modifier Name is " + currentModifier[0].group_name);
        this.isRestExists = true;
        //set Cat name to old name:
        this.catName = currentModifier[0].group_name;
        this.userPhone = currentRestaurant[0].rest_phone;
        this.userName = currentRestaurant[0].rest_name;
        this.userAddress = currentRestaurant[0].rest_address;
        //get users info
        this.user.uId = JSON.parse(user).id;
        this.user.userId = JSON.parse(user).user_id;
        this.user.uName = JSON.parse(user).name;
        this.user.uEmail = JSON.parse(user).email;
        this.user.uPassword = JSON.parse(user).password;
        this.user.uMemberSince = JSON.parse(user).member_since;
        this.user.uAddress = JSON.parse(user).full_address;
        this.user.uPhone = JSON.parse(user).phone_number;
        this.user.uRole = JSON.parse(user).role;
        //if role isn't manager or admin, redirect
        if (currentRestaurant[0].active == 0) {
          //if restaurant isn't active
          this.$router.push({ name: "MyRestaurants" });
        } else if (
          JSON.parse(user).role !== "mngr" &&
          JSON.parse(user).role !== "admn"
        ) {
          this.$router.push({ name: "Login" });
        }
      }
    } else {
      this.$router.push({ name: "Login" });
    }
  },
  computed: {
    ...mapState([
      "__RestaurantId",
      "__RestaurantEmail",
      "__RestaurantRole",
      "__RestaurantName",
      "__MainUrl",
    ]),
    ...mapGetters(["MainUrl"]),
  },
  methods: {
    ...mapMutations(["setRestaurantInfo"]),
    //validate Restaurant Name
    validateCategoryName(e) {
      let val = e.target.value;
      this.validateCategoryNameInput(val);
    },
    validateCategoryNameInput(val) {
      if (val == "") {
        this.catNameErr = true;
        this.iscatNameValidated = false;
        this.catNameMsg = "Must Enter Modifier Name ..";
      } else {
        this.catNameErr = false;
        this.iscatNameValidated = true;
        this.catNameMsg = "";
      }
    },
    validateMaxSelection(e) {
      let val = e.target.value;
      this.validateMaxSelectionInput(val);
    },
    validateMaxSelectionInput(val) {
      if (val == "") {
        this.maxSelectionErr = true;
        this.ismaxSelectionValidated = false;
        this.maxSelectionMsg = "Select # of selection for each item ..";
      } else {
        this.maxSelectionErr = false;
        this.ismaxSelectionValidated = true;
        this.maxSelectionMsg = "";
      }
    },
    async UpdateCurrentMenuCategory() {
      this.validateCategoryNameInput(this.catName);
      this.validateMaxSelectionInput(this.maxSelection);
      if (this.iscatNameValidated && this.ismaxSelectionValidated) {
        this.signUpBtn = false;
        //show Result
        let fd = new FormData();
        fd.append("userId", this.user.userId);
        fd.append("catName", this.catName);
        fd.append("restId", this.restId);
        fd.append("catId", this.catId);
        fd.append("maxSelection", this.maxSelection);
        // fd.append("restNum", this.restNum);
        let rst = await axios.post(
          this.apiMainUrl + `?action=UpdateCurrentMenuModifier`,
          fd
        );
        console.log(rst);
        const resultData = rst.data;
        if (rst.status == 200) {
          if (resultData.error) {
            console.warn("Connection Error Happened on Adding New Modifier");
            this.resultErrMsg = resultData.message;
            this.resultErr = true;
            this.resultSuccessMsg = "";
            this.resultSuccess = false;
            this.signUpBtn = true;
          } else {
            this.signUpBtn = false;
            console.log("New modifier has been added..");
            //if everything is okay
            this.resultErrMsg = "";
            this.resultErr = false;
            this.resultSuccess = true;
            //set restaurant to local host: current_restaurants_data
            // localStorage.setItem(
            //   "current_restaurants_data",
            //   JSON.stringify(resultData.current_restaurants_data)
            // );
            //redirect only if customer
            //add new Modifier to current_user_menu_categories_data
            //now get current categories, then push a new object to it and last set a new localhost
            var currentModifiers = JSON.parse(
              localStorage.getItem("current_user_menu_modifiers_data")
            );
            //this is an array of object [{}], so only get the object of it [0]
            // var newMenuCategory =
            //   resultData.current_restaurants_menu_category_data[0];
            // currentModifiers.push(newMenuCategory); //add this object to newMenuCategory array
            for (let i = 0; i < currentModifiers.length; i++) {
              if (currentModifiers[i].group_name_rand_id === this.catId) {
                currentModifiers[i].group_name = this.catName;
                currentModifiers[i].max_selection = this.maxSelection;
              }
            }
            localStorage.setItem(
              "current_user_menu_modifiers_data",
              JSON.stringify(currentModifiers)
            );
            //https://stackoverflow.com/questions/35963412/append-data-to-localstorage-object
            this.resultSuccessMsg = resultData.message;
            //redirect to current restaurant page
            setTimeout(() => {
              this.$router.push({
                name: "CurrentRestaurantMenu",
                params: { id: this.restNum, restId: this.restId },
              });
              console.log("Restaurant Name: " + this.userName);
            }, 2000);
          }
        }
      } else {
        this.signUpBtn = true;
        this.validateCategoryNameInput(this.catName);
        this.resultSuccessMsg = "";
        this.resultSuccess = false;

        this.resultErrMsg = "Must enter all required information";
        this.resultErr = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
$navColor: #3f51b6;
nav a {
  text-decoration: none;
  color: $navColor;
  font-weight: bold;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
.form-data-error select {
  border-color: red;
}
</style>
